export default function MembershipHero() {
  return (
    <section className="relative h-[70vh] w-full overflow-hidden mt-20">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/c246534753e025370c2e2f453b0cd559.jpg"
          alt="Membership Club"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
      </div>

      <div className="relative h-full flex items-center justify-center">
        <div className="text-center px-6 max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-light tracking-[0.15em] text-white mb-6">
            MEMBERSHIP
          </h1>
          <div className="w-32 h-px bg-gold mx-auto mb-8"></div>
          <p className="text-xl md:text-2xl font-serif text-white/90 tracking-wide">
            Exclusive Access to Elevated Wellness
          </p>
        </div>
      </div>
    </section>
  );
}